import React from 'react';
import { AlertCircle } from 'lucide-react';

const TERRA = '#EF4C23';

const getStatusLabel = (status) => {
  if (!status) return '';
  switch (status) {
    case 'pending': return 'En attente';
    case 'preparing': return 'En préparation';
    case 'ready': return 'Prêt';
    case 'delivered': return 'Livré';
    case 'cancelled': return 'Annulé';
    default: return status;
  }
};

const ConfirmStatusChangeModal = ({
  isOpen,
  onClose,
  onConfirm,
  order,
  newStatus,
  oldStatus,
}) => {
  if (!isOpen) return null;

  const isCancel = newStatus === 'cancelled';

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div
        className="fixed inset-0"
        style={{ background: 'rgba(5,16,4,0.5)' }}
        onClick={onClose}
        aria-hidden="true"
      />
      <div className="flex min-h-screen items-center justify-center p-4">
        <div className="relative w-full" style={{ maxWidth: '440px', background: '#FCFBF5', borderRadius: '28px', padding: 'clamp(24px, 3vw, 32px)', display: 'flex', flexDirection: 'column', gap: '18px' }}>
          <div className="flex items-center gap-3">
            <span style={{ flex: 'none', width: '36px', height: '36px', borderRadius: '999px', background: isCancel ? '#FEF0EA' : 'rgba(255,199,23,0.22)', display: 'grid', placeItems: 'center', color: isCancel ? '#A32C0F' : '#054625' }}>
              <AlertCircle size={18} />
            </span>
            <h2 style={{ margin: 0, fontFamily: 'Fraunces, Georgia, serif', fontWeight: 700, fontSize: '20px' }}>Confirmer le changement</h2>
          </div>

          {order && (
            <p style={{ margin: 0, fontFamily: 'Archivo, sans-serif', fontSize: '12.5px', color: 'rgba(5,16,4,0.55)' }}>Commande {order.orderNumber || `#${order.id}`}</p>
          )}
          <p style={{ margin: 0, fontSize: '14.5px', lineHeight: 1.55, color: '#051004' }}>
            Changer le statut de <strong>{getStatusLabel(oldStatus)}</strong> vers <strong>{getStatusLabel(newStatus)}</strong> ?
          </p>

          <div className="flex gap-2.5 justify-end flex-wrap">
            <button
              type="button"
              onClick={onClose}
              style={{ border: '1px solid rgba(5,16,4,0.16)', cursor: 'pointer', background: 'transparent', color: '#054625', fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '14px', minHeight: '44px', padding: '0 20px', borderRadius: '999px' }}
            >
              Revenir
            </button>
            <button
              type="button"
              onClick={onConfirm}
              style={{ border: 'none', cursor: 'pointer', background: isCancel ? '#A32C0F' : TERRA, color: '#FCFBF5', fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: '14px', minHeight: '44px', padding: '0 22px', borderRadius: '999px' }}
            >
              Confirmer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmStatusChangeModal;
